import React, { useState } from "react";
import { useCart } from "../context/CartContext";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const [showPincodeModal, setShowPincodeModal] = useState(false); // ✅ add this
  const [pincode, setPincode] = useState(""); // ✅ for input field

  const { cartItems, removeFromCart, updateQuantity } = useCart();
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem("access");

  // 🧮 Totals
  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );
  const discount = totalPrice * 0.25;
  const finalAmount = totalPrice - discount;

  // 🛒 Empty cart
  if (cartItems.length === 0) {
    return (
      <div className="text-center py-20">
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          🛒 Your cart is empty
        </h2>
        <Link
          to="/all-products"
          className="mt-4 inline-block bg-blue-600 text-white px-6 py-3 rounded-md"
        >
          Shop Now
        </Link>
      </div>
    );
  }

  return (
    <div className="bg-[#f1f3f6] py-6 min-h-screen">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* ---------------- LEFT SECTION ---------------- */}
        <div className="col-span-2">
          {/* 📦 Saved Address Section */}
          <div className="bg-white border rounded-md p-5 shadow-sm flex justify-between items-center">
            <p className="font-medium text-gray-800">From Saved Addresses</p>

            {/* 🟦 Enter Delivery Pincode Button */}
            <button
              onClick={() => setShowPincodeModal(true)}
              className="text-blue-600 font-medium border border-gray-300 px-4 py-1.5 rounded-md hover:bg-blue-50 transition"
            >
              Enter Delivery Pincode
            </button>
          </div>

          {/* Cart Items Container */}
          <div className="bg-white border rounded-md shadow-sm mt-2">
            {cartItems.map((item, index) => (
              <div
                key={item.id}
                className={`p-5 ${
                  index !== cartItems.length - 1 ? "border-b" : ""
                }`}
              >
                <div className="flex justify-between items-start">
                  {/* Product Image + Details */}
                  <div className="flex gap-4">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-28 h-28 object-cover rounded"
                    />
                    <div>
                      <h3 className="font-semibold text-[16px] leading-tight">
                        {item.title}
                      </h3>
                      <p className="text-gray-500 text-sm">
                        Seller:
                        <span className="font-medium text-gray-700">
                          {" "}
                          Flashstar Commerce
                        </span>
                      </p>

                      {/* Price Section */}
                      <div className="flex items-center gap-2 mt-2">
                        <span className="text-[18px] font-semibold text-gray-900">
                          ₹{item.price}
                        </span>
                        <span className="line-through text-gray-400 text-sm">
                          ₹{Math.round(item.price * 1.3)}
                        </span>
                        <span className="text-green-600 text-sm font-medium">
                          25% Off
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Delivery Info */}
                  <div className="text-sm text-gray-500 whitespace-nowrap">
                    Delivery by <b>Sun Nov 9</b>
                  </div>
                </div>

                {/* Quantity + Actions */}
                <div className="flex items-center justify-between mt-5">
                  <div className="flex items-center">
                    <button
                      onClick={() =>
                        updateQuantity(item.id, Math.max(1, item.quantity - 1))
                      }
                      className="border border-gray-400 w-8 h-8 rounded-full text-lg flex items-center justify-center hover:bg-gray-100"
                    >
                      −
                    </button>
                    <span className="mx-4 font-medium">{item.quantity}</span>
                    <button
                      onClick={() =>
                        updateQuantity(item.id, item.quantity + 1)
                      }
                      className="border border-gray-400 w-8 h-8 rounded-full text-lg flex items-center justify-center hover:bg-gray-100"
                    >
                      +
                    </button>
                  </div>

                  <div className="flex gap-8 text-sm font-semibold text-gray-800">
                    <button className="hover:text-orange-600">
                      SAVE FOR LATER
                    </button>
                    <button
                      onClick={() => removeFromCart(item.id)}
                      className="hover:text-red-600"
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
              </div>
            ))}

            {/* PLACE ORDER BUTTON */}
            <div className="bg-white border-t p-5 flex justify-end">
              <button
                onClick={() => navigate("/checkout")}

                className="bg-orange-500 hover:bg-orange-600 text-white px-16 py-3 rounded-md font-semibold"
              >
                PLACE ORDER
              </button>
            </div>
          </div>
        </div>

        {/* 💰 RIGHT SECTION (Flipkart Style) */}
        <div className="h-fit sticky top-4">
          {/* Main Price Box */}
          <div className="bg-white border rounded-md shadow-sm p-5">
            <h3 className="text-[15px] font-semibold mb-4 text-gray-800 border-b pb-2">
              PRICE DETAILS
            </h3>

            <div className="text-[15px] text-gray-700 space-y-3">
              {/* Price */}
              <div className="flex justify-between items-center">
                <p>
                  Price ({cartItems.length}{" "}
                  {cartItems.length > 1 ? "items" : "item"})
                </p>
                <p>₹{totalPrice.toLocaleString()}</p>
              </div>

              {/* Discount */}
              <div className="flex justify-between items-center">
                <p>Discount</p>
                <p className="text-green-600 font-medium">
                  − ₹{discount.toLocaleString()}
                </p>
              </div>

              {/* Dotted line divider */}
              <hr className="border-dashed border-gray-300 my-2" />

              {/* Total Amount */}
              <div className="flex justify-between items-center">
                <p className="font-semibold text-[17px] text-gray-900">
                  Total Amount
                </p>
                <p className="font-bold text-[18px] text-gray-900">
                  ₹{finalAmount.toLocaleString()}
                </p>
              </div>

              {/* Second dashed line before savings */}
              <hr className="border-dashed border-gray-300 my-3" />

              {/* Savings */}
              <p className="text-green-600 font-semibold text-[15px]">
                You will save ₹{discount.toLocaleString()} on this order
              </p>
            </div>
          </div>

          {/* ✅ Outside Safe Payments Note */}
          <div className="flex items-start gap-2 mt-5 text-gray-500 text-[13px] leading-snug">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.8"
              stroke="currentColor"
              className="w-5 h-5 text-gray-600 flex-shrink-0 mt-[2px]"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <p>
              Safe and Secure Payments. Easy returns. 100% Authentic products.
            </p>
          </div>
        </div>
      </div>

      {/* 🧩 Pincode Modal - inside return */}
      {showPincodeModal && (
        <div
          onClick={() => setShowPincodeModal(false)}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-lg shadow-lg w-[380px] p-6 relative"
          >
            <button
              onClick={() => setShowPincodeModal(false)}
              className="absolute top-3 right-4 text-gray-600 hover:text-black text-2xl font-bold"
            >
              ×
            </button>

            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              Select Delivery Address
            </h2>

            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/633/633652.png"
                alt="address icon"
                className="w-8 h-8 opacity-70"
              />
              <p className="text-gray-700 text-[15px]">
                Log in to view saved addresses
              </p>
            </div>

            <hr className="my-3" />

            <h3 className="font-semibold text-gray-800 mb-2">
              Use pincode to check delivery info
            </h3>

            <div className="flex items-center gap-3">
              <input
                type="text"
                value={pincode}
                onChange={(e) => setPincode(e.target.value)}
                placeholder="Enter pincode"
                className="border-b border-gray-400 focus:border-blue-600 outline-none flex-1 py-1 text-gray-800"
              />
              <button
                onClick={() => alert(`Pincode submitted: ${pincode}`)}
                className="bg-gray-200 text-gray-600 font-semibold px-4 py-1.5 rounded-md hover:bg-gray-300"
              >
                Submit
              </button>
            </div>

            <button
              onClick={() => alert("Fetching your current location...")}
              className="text-blue-600 font-medium mt-4 hover:underline flex items-center gap-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 11c1.104 0 2-.896 2-2s-.896-2-2-2-2 .896-2 2 .896 2 2 2zm0 0v9m-6-9a9 9 0 1118 0 9 9 0 01-18 0z"
                />
              </svg>
              Use my current location
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartPage;
